import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AgreementList from "./AgreementList";
import ClaimsList from "./ClaimsList";
import MultiSelectChipsComponent from "./MultiSelectChipsComponent";
import InvoiceList from "./InvoiceList";
import { AuthContext } from "../AuthContext";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agmclm-tabpanel-${index}`}
      aria-labelledby={`agmclm-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `agmclm-tab-${index}`,
    "aria-controls": `agmclm-tabpanel-${index}`,
  };
}

const AgreementsClaimsTabs = ({
  displayType,
  dealer,
  showDealer,
  tenant,
  activeTab = 0,
}) => {
  const [value, setValue] = React.useState(0);
  const [businessUnits, setBusinessUnits] = React.useState([]);
  const [selectedBusinessUnits, setSelectedBusinessUnits] = React.useState([]);
  const { group} = useContext(AuthContext);
  console.log("AgreementsClaimsTab Dealer : ", dealer);
  console.log("Agreements Claims Tab tenants :", tenant);
  console.log("Agreements Claims Tab Group :", group);

  useEffect(() => {
    // For non-admin groups, there is no INVOICES tab (index 0 for admin).
    // Admin tab indices: 0=INVOICES, 1=AGREEMENTS, 2=CLAIMS
    // Non-admin tab indices:                        0=AGREEMENTS, 1=CLAIMS
    // Shift down by 1 for non-admin so callers can use admin indices universally.
    const resolvedTab =
      group !== "jbw-admin" && activeTab > 0 ? activeTab - 1 : activeTab;
    console.log("active tab :", resolvedTab);
    setValue(resolvedTab);
  }, [activeTab, group]);

  useEffect(() => {
    if (tenant) {
      const tenantDetails =
        typeof dealer.TenantsDetails === "string"
          ? JSON.parse(dealer.TenantsDetails)
          : dealer.TenantsDetails;
      if (tenantDetails && tenantDetails.length > 0) {
        const filteredBus = tenantDetails.filter(
          (ft) => ft.tenantId === tenant,
        );
        // console.log("businessunits :", filteredBus[0].businessUnits);
        setBusinessUnits(filteredBus[0]?.businessUnits);
      }else{
        setBusinessUnits([]);
      }
    }
  }, [tenant]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBusinessUnit = (param) => {
    console.log("handle businessUnit : ",param);
    setSelectedBusinessUnits(param);
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 2,
        boxShadow: 4,
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "left",
          alignItems: "center",
        }}
      >
        <Box>
          {group === "jbw-admin" ? (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Agreements Claims Tabs"
            >
              <Tab label="INVOICES" {...a11yProps(0)} />
              <Tab label="AGREEMENTS" {...a11yProps(1)} />
              <Tab label="CLAIMS" {...a11yProps(2)} />
            </Tabs>
          ) : (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Agreements Claims Tabs"
            >
              <Tab label="AGREEMENTS" {...a11yProps(0)} />
              <Tab label="CLAIMS" {...a11yProps(1)} />
            </Tabs>
          )}
        </Box>
        {(tenant && businessUnits && businessUnits.length>0) ? (
          <Box>
            <MultiSelectChipsComponent
              businessUnits={businessUnits}
              onBusinessUnitSelected={handleBusinessUnit}
            />
          </Box>
        ) : (
          <></>
        )}
      </Box>
      {group === "jbw-admin" ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <InvoiceList
              showDealer={showDealer}
              displayType={displayType}
              dealer={dealer}
              tenant={tenant}
              businessUnits={
                selectedBusinessUnits && selectedBusinessUnits.length > 0
                  ? selectedBusinessUnits.map((bu) => bu.businessUnitId)
                  : []
              }
            />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <AgreementList
              showDealer={showDealer}
              displayType={displayType}
              dealer={dealer}
              tenant={tenant}
              businessUnits={
                selectedBusinessUnits && selectedBusinessUnits.length > 0
                  ? selectedBusinessUnits.map((bu) => bu.businessUnitId)
                  : []
              }
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <ClaimsList
              showDealer={showDealer}
              displayType={displayType}
              dealer={dealer}
              tenant={tenant}
              businessUnits={
                selectedBusinessUnits && selectedBusinessUnits.length > 0
                  ? selectedBusinessUnits.map((bu) => bu.businessUnitId)
                  : []
              }
            />
          </CustomTabPanel>
        </>
      ) : (
        <>
          <CustomTabPanel value={value} index={0}>
            <AgreementList
              showDealer={showDealer}
              displayType={displayType}
              dealer={dealer}
              tenant={tenant}
              businessUnits={
                selectedBusinessUnits && selectedBusinessUnits.length > 0
                  ? selectedBusinessUnits.map((bu) => bu.businessUnitId)
                  : []
              }
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ClaimsList
              showDealer={showDealer}
              displayType={displayType}
              dealer={dealer}
              tenant={tenant}
              businessUnits={
                selectedBusinessUnits && selectedBusinessUnits.length > 0
                  ? selectedBusinessUnits.map((bu) => bu.businessUnitId)
                  : []
              }
            />
          </CustomTabPanel>
        </>
      )}
    </Box>
  );
};

export default AgreementsClaimsTabs;
